<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "WebhookUpdated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.webhookUpdated', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                webhookName: this.$_.get(this.activity, 'payload.name'),
                webhookUrl: this.$_.get(this.activity, 'payload.url')
            });
        }
    }
};
</script>

